"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgImages = void 0;
var config_1 = __importDefault(require("next/config"));
var publicRuntimeConfig = (0, config_1.default)().publicRuntimeConfig;
var EmptyStateGlassSvg = "".concat(publicRuntimeConfig.BASE_PATH, "/assets/images/glass.svg");
var CheckboxDisabledSvg = "".concat(publicRuntimeConfig.BASE_PATH, "/assets/images/checkboxDisabled.svg");
var DropdownArrowSvg = "".concat(publicRuntimeConfig.BASE_PATH, "/assets/images/dropdownArrow.svg");
exports.SvgImages = {
    emptyStateGlass: EmptyStateGlassSvg,
    checkboxDisabled: CheckboxDisabledSvg,
    dropdownArrowSvg: DropdownArrowSvg,
};
